(function () {
  'use strict';

  function initDrawerNavigation() {
    var container = document.getElementById('drawer-panels');
    if (!container) return;

    var backBtnLevel2 = document.getElementById('drawer-back-btn');
    var backTitleLevel2 = document.getElementById('drawer-panel-title');
    var backBtnLevel3 = document.getElementById('drawer-back-btn-level3');
    var backTitleLevel3 = document.getElementById('drawer-panel-title-level3');
    var triggers = container.querySelectorAll('[data-trigger-submenu]');

    // Handle Open Sub-menu
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var targetId = trigger.getAttribute('data-trigger-submenu');
        var parentTitle = trigger.getAttribute('data-parent-title') || 'BACK';
        var currentPanel = trigger.closest('.drawer-panel');
        if (!currentPanel) return;

        var currentLevel = parseInt(currentPanel.getAttribute('data-level'), 10);

        // Target submenu list
        var targetMenu = document.getElementById(targetId);
        if (targetMenu) {
          // If we are going to Level 3, only hide level 3 submenus.
          // Otherwise hide level 2 submenus.
          var isLevel3 = targetMenu.classList.contains('drawer-submenu-list--level3');
          var selector = isLevel3 ? '.drawer-submenu-list--level3' : '.drawer-submenu-list:not(.drawer-submenu-list--level3)';
          
          container.querySelectorAll(selector).forEach(function (menu) {
            menu.style.display = 'none';
          });

          targetMenu.style.display = 'block';
        }

        if (currentLevel === 1) {
          if (backTitleLevel2) {
            backTitleLevel2.textContent = parentTitle.toUpperCase();
          }
          container.setAttribute('data-panel', '2');
        } else if (currentLevel === 2) {
          if (backTitleLevel3) {
            backTitleLevel3.textContent = parentTitle.toUpperCase();
          }
          container.setAttribute('data-panel', '3');
        }
      });
    });

    // Handle Back Button Level 2 click
    if (backBtnLevel2) {
      backBtnLevel2.addEventListener('click', function () {
        container.setAttribute('data-panel', '1');
      });
    }

    // Handle Back Button Level 3 click
    if (backBtnLevel3) {
      backBtnLevel3.addEventListener('click', function () {
        container.setAttribute('data-panel', '2');
      });
    }

    // Reset back to Panel 1 when drawer is closed
    var navClose = document.getElementById('nav-close');
    var overlay = document.querySelector('.mobile-nav__overlay');
    
    function resetPanel() {
      setTimeout(function () {
        container.setAttribute('data-panel', '1');
      }, 350);
    }

    if (navClose) {
      navClose.addEventListener('click', resetPanel);
    }
    if (overlay) {
      overlay.addEventListener('click', resetPanel);
    }
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerNavigation);
  } else {
    initDrawerNavigation();
  }
})();
